var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.81865V17.1812C23 17.5055 22.9182 17.8123 22.7675 18.0752L16.4546 13.3159L22.6082 8.68359C22.8536 8.99475 23 9.38917 23 9.81865Z",
    fill: "#52596B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.143 18.7327C21.8718 18.9037 21.5531 19.0001 21.2129 19.0001H6.78708C6.44689 19.0001 6.12823 18.9037 5.85693 18.7327L12.2947 13.8813L13.0139 14.4248C13.2895 14.6308 13.6426 14.7359 13.9957 14.7359C14.3488 14.7359 14.7019 14.6308 14.9775 14.4248L15.6966 13.8813L22.143 18.7327Z",
    fill: "#52596B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5455 13.3159L5.23254 18.0752C5.08612 17.8123 5 17.5055 5 17.1812V9.81865C5 9.38917 5.14641 8.99475 5.39187 8.68359L11.5455 13.3159Z",
    fill: "#52596B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8503 8.11833L15.7053 12.7506L14.956 13.3159L14.4522 13.6928C14.2153 13.8725 13.7847 13.8725 13.5479 13.6928L13.044 13.3159L12.2948 12.7506L6.14978 8.11833C6.34787 8.04382 6.56318 8 6.7871 8H21.2129C21.4369 8 21.6522 8.04382 21.8503 8.11833Z",
    fill: "#52596B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7a2a6bf2b92d722608495aa5fef1ddb6.svg";
export { ForwardRef as ReactComponent };